import { render, staticRenderFns } from "./ModalDeleteKonten.vue?vue&type=template&id=63c93a68&scoped=true&"
import script from "./ModalDeleteKonten.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteKonten.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteKonten.vue?vue&type=style&index=0&id=63c93a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c93a68",
  null
  
)

export default component.exports